import { render } from "./EventDetailEnded.vue?vue&type=template&id=4fc0611e&scoped=true"
import script from "./EventDetailEnded.vue?vue&type=script&lang=js"
export * from "./EventDetailEnded.vue?vue&type=script&lang=js"

import "./EventDetailEnded.vue?vue&type=style&index=0&id=4fc0611e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4fc0611e"

export default script